import React from 'react';
import type { SpaceProps } from 'styled-system';

import { MessageType } from '../../enums/Alert';
import { useLocalization } from '../../providers/LocaleProvider';
import type { ErrorMessage } from '../../types/error';
import { getErrorMessageTranslator } from '../../utils/error-handlers/error-message';
import StyledDrawerAlert from './StyledDrawerAlert';

interface DrawerFormAlertProps extends SpaceProps {
  message: ErrorMessage;
}

const DrawerFormAlert = ({ message, ...spaceProps }: DrawerFormAlertProps) => {
  const { t } = useLocalization();
  const translateErrorMessage = getErrorMessageTranslator(t);
  const translatedMessage = translateErrorMessage(message);

  return <StyledDrawerAlert type={MessageType.Error} html={translatedMessage} {...spaceProps} />;
};
export default DrawerFormAlert;
